import { ModulesMap } from '@/config/data/modulesMaps'

import DataTransferModule from '@/services/dataTransferModule'

import WorkReportPhotosApi from '@/services/apiServiceModules/workReportPhotosApi.js'
const workReportPhotosApi = new WorkReportPhotosApi()

export default class WorkReportPhotosDt extends DataTransferModule {
    constructor() {
        super(ModulesMap.WORK_REPORT_PHOTOS, workReportPhotosApi, {
            useCache: true,
        })
    }
}
